import { Helmet } from "react-helmet-async";
import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Campaigns from "@/components/Campaigns";
import Services from "@/components/Services";
import Reels from "@/components/Reels";
import Team from "@/components/Team";
import Testimonials from "@/components/Testimonials";
import BrandScroll from "@/components/BrandScroll";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import MidStrip from "@/components/MidStrip";

const WhatsAppIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.004 3C8.832 3 3 8.832 3 16.004c0 2.293.602 4.535 1.746 6.512L3.08 29l6.641-1.645A12.91 12.91 0 0 0 16.004 29C23.176 29 29 23.168 29 16.004 29 8.832 23.176 3 16.004 3Zm0 23.746a10.7 10.7 0 0 1-5.461-1.496l-.391-.23-3.941.973 1.051-3.844-.254-.406a10.68 10.68 0 0 1-1.645-5.739c0-5.883 4.758-10.641 10.641-10.641 5.875 0 10.633 4.758 10.633 10.641 0 5.875-4.758 10.742-10.633 10.742Zm5.836-7.969c-.32-.16-1.883-.93-2.176-1.035-.293-.109-.508-.16-.723.16-.211.32-.828 1.035-1.016 1.246-.188.215-.375.242-.695.082-.32-.16-1.352-.5-2.574-1.59-.953-.848-1.594-1.895-1.781-2.215-.188-.32-.02-.492.141-.652.145-.145.32-.375.48-.563.16-.188.215-.32.32-.535.109-.215.055-.402-.027-.563-.082-.16-.723-1.742-.988-2.387-.258-.621-.52-.535-.723-.543h-.617c-.211 0-.563.078-.855.402-.293.32-1.121 1.094-1.121 2.668s1.148 3.09 1.309 3.305c.16.211 2.258 3.449 5.473 4.836.766.332 1.363.531 1.828.68.77.246 1.469.211 2.023.129.617-.094 1.883-.77 2.148-1.512.266-.746.266-1.383.188-1.516-.078-.133-.293-.211-.613-.371Z" />
  </svg>
);

function App() {
  return (
    <>
      <Helmet>
        <title>Best Branding Agency in Hyderabad | Dot Media</title>

        <meta
          name="description"
          content="Dot Media is the leading branding and digital marketing agency in Hyderabad. 12+ years of creative excellence in brand strategy, social media marketing and digital campaigns."
        />

        <meta
          name="keywords"
          content="best branding agency in hyderabad, leading branding agency in hyderabad, digital marketing agency in hyderabad, social media marketing agency in hyderabad, advertising agency hyderabad"
        />

        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="Best Branding Agency in Hyderabad | Dot Media"
        />

        <meta
          property="og:description"
          content="Leading branding and digital marketing agency in Hyderabad with 12+ years of experience in brand strategy, social media and digital campaigns."
        />

        <meta property="og:url" content="https://dotmedia.co.in/" />

        <meta property="og:type" content="website" />

        <meta
          property="og:image"
          content="https://dotmedia.co.in/images/dotMediaLogo.png"
        />

        <meta property="og:site_name" content="Dot Media" />

        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Best Branding Agency in Hyderabad | Dot Media"
        />

        <meta
          name="twitter:description"
          content="Leading branding and digital marketing agency in Hyderabad with 12+ years of experience."
        />

        <meta
          name="twitter:image"
          content="https://dotmedia.co.in/images/dotMediaLogo.png"
        />

        <link rel="canonical" href="https://dotmedia.co.in/" />
      </Helmet>

      <div className="App font-sans text-black bg-white antialiased">
        <Nav />
        <main>
          <Hero />
          <Campaigns />
          <MidStrip />
          <Services />
          <Reels />
          <Team />
          <Testimonials />
          <BrandScroll />
          <Contact />
        </main>
        <Footer />
        <a
          href="https://wa.me/917075772733"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          style={{
            position: "fixed",
            bottom: "45px",
            right: "45px",
            zIndex: 9999,
          }}
          className="w-100 h-100 bg-[#25D366] hover:bg-[#1ebe5d] flex items-center justify-center rounded-full shadow-lg transition-colors"
        >
          <WhatsAppIcon size={60} />
        </a>
        <Toaster
          position="top-center"
          expand={true}
          toastOptions={{
            style: {
              background: "#111111",
              color: "#ffffff",
              border: "none",
              borderLeft: "5px solid #E60000",
              borderRadius: "0px",
              fontSize: "16px",
              padding: "20px 28px",
              minWidth: "420px",
              fontWeight: "700",
              fontFamily: "Manrope, system-ui, sans-serif",
              letterSpacing: "0.02em",
              boxShadow: "0 8px 32px rgba(0,0,0,0.45)",
            },
            error: {
              style: {
                background: "#111111",
                color: "#ffffff",
                borderLeft: "5px solid #E60000",
              },
            },
            success: {
              style: {
                background: "#111111",
                color: "#ffffff",
                borderLeft: "5px solid #5b726f",
              },
            },
          }}
        />
      </div>
    </>
  );
}

export default App;
